import { imageUrl } from "@/utils/constants";
import FA_LANG from "@/assets/locale/fa";
import ResponseInput from "./inputs/ResponseInput";
import { useEffect, useId, useState } from "react";

export type QuizProps = {
  selectedQuiz: Quiz;
  updateQuizDetail: Function;
  addNewChoice?: Function;
  removeChoice?: Function;
  updateQuestion?: Function;
  addNewAnswer?: Function;
  removeAnswer?: Function;
  questionDirection: string;
};

export default function Labeling({
  selectedQuiz,
  updateQuizDetail,
  updateQuestion,
  addNewChoice,
  removeChoice,
  questionDirection,
}: QuizProps) {
  const [definedPoints, setDefinedPoints] = useState<Point[]>([]);

  useEffect(() => {
    var areas: Point[] = [];
    for (let index = 0; index < selectedQuiz.quiz_detail_json.length; index++) {
      const element = selectedQuiz.quiz_detail_json[index];
      if (element.offsetX) {
        areas.push({ x: element.offsetX, y: element.offsetY });
      }
    }
    setDefinedPoints(areas);
  }, [selectedQuiz]);

  const handleQuestionChange = (value: string, i: number) => {
    const updatedSelectedQuiz: Quiz = {
      ...selectedQuiz,
      question: value,
    };
    if (updateQuestion) updateQuestion(updatedSelectedQuiz);
  };

  function handleQuestionFileChange(image: any): void {
    const updatedSelectedQuiz: Quiz = {
      ...selectedQuiz,
      question_file: image,
      question_link: "",
      question_file_id: undefined,
    };
    if (updateQuestion) updateQuestion(updatedSelectedQuiz);
  }

  const addQuizDetails = (offsetX: number, offsetY) => {
    var i = selectedQuiz.quiz_detail_json.length;
    addNewChoice!(
      {
        id: "choice" + (i + 1),
        choice: {
          fileId: "",
          text: "",
          url: "",
        },
        isCorrect: false,
        ordering: i + 1,
        correctOrder: i + 1,
        letterWise: false,
        isChoice: true,
        offsetX: offsetX,
        offsetY: offsetY,
        answers: [
          {
            id: "answer" + (i + 1) + "1",
            answer: {
              fileId: "",
              text: "",
              url: "",
            },
          },
        ],
      },
      i
    );
  };

  const removeQuizDetails = (i: string) => {
    removeChoice!(i);
  };

  const updateChoiceValue = (value: string, i: number) => {
    let updated = selectedQuiz.quiz_detail_json?.map((details, index) =>
      i === index
        ? { ...details, choice: { ...details.choice, text: value } }
        : details
    );
    updateQuizDetail(updated[i]);
  };

  function handleQuestionAudioChange(audio: any): void {
    const updatedSelectedQuiz: Quiz = {
      ...selectedQuiz,
      question_voice: audio,
      question_voice_link: undefined,
    };
    if (updateQuestion) updateQuestion(updatedSelectedQuiz);
  }
  // const imageRef = useRef<HTMLImageElement | null>(null);

  const handleImageClick = (
    event: React.MouseEvent<HTMLImageElement>,
    imageRef: React.MutableRefObject<HTMLImageElement>
  ) => {
    if (!imageRef.current) return;
    const { offsetX, offsetY } = event.nativeEvent;

    setDefinedPoints([...definedPoints, { x: offsetX, y: offsetY }]);
    addQuizDetails(offsetX, offsetY);
  };
  const removePoints = (index: number) => {
    const selectedQuiz1 = selectedQuiz.quiz_detail_json.find(
      (x, inx) => inx === index
    );

    const newPoints = definedPoints.filter((x, inx) => inx !== index);
    setDefinedPoints(newPoints);
    removeQuizDetails(selectedQuiz1.id);
  };
  const image_id = useId();

  return (
    <div className="flex flex-col gap-8 items-start w-full">
      <ResponseInput
        inputValue={selectedQuiz.question}
        valueUpdated={handleQuestionChange}
        placeHolder={FA_LANG.QUESTION_INPUT}
        handleImageChange={handleQuestionFileChange}
        id={`file-input-question-test-${image_id}`}
        styleClass=" h-[400px] gap-6 "
        index={0}
        hasFile={true}
        imageUrl={
          selectedQuiz.question_link
            ? imageUrl + selectedQuiz.question_link
            : selectedQuiz.question_file
              ? URL.createObjectURL(selectedQuiz.question_file)
              : undefined
        }
        tabIndex={0}
        imageHeight="h-[350px]"
        imageWidth="w-[300px]"
        questionInput={true}
        questionDirection={questionDirection}
        handleVoiceChange={handleQuestionAudioChange}
        hasAudio={true}
        inputVoice={selectedQuiz.question_voice_link}
        onImageClick={handleImageClick}
        definedPoints={definedPoints}
        removePoints={removePoints}
      />
      {/* <div
        className={`flex w-full overflow-auto ${
          selectedQuiz?.quiz_detail_json?.length <= 3 ? "" : "gap-x-1.5"
        }`}
      >
        {renderInputs()}
      </div> */}
    </div>
  );
}
